import React from 'react';

import useLocale from 'components/useLocale';
import Workflow from 'components/workflow/Workflow';

import useStyles from 'components/profileManagement/ProfileManagement.styles';
import SecurityInformation from './SecurityInformation';

export const SecurityInformationPageComponent = ({ ...props }) => {
  const { containerPadding } = useStyles();
  const locale = useLocale();

  return (
    <Workflow returnUrl={false} showFooter={false} title={locale['profile.securityInformation']}>
      <div className={containerPadding}>
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <SecurityInformation {...props} />
      </div>
    </Workflow>
  );
};

export default SecurityInformationPageComponent;
